import { PlanFeature } from '../enums/plan.enum';
import { PLAN_FEATURE_CATEGORIES, PLAN_FEATURE_CATEGORY_LABELS, PLAN_FEATURE_LABELS } from '../constants/plan.constant';
import { PLAN_DEFINITIONS } from '../plans/plans';
export function hasFeature(tenantFeatures, feature) {
  return tenantFeatures.includes(feature);
}
export function isAtLimit(currentCount, limit) {
  if (limit === null) return false;
  return currentCount >= limit;
}
const SORTED_PLANS = Object.values(PLAN_DEFINITIONS).sort((a, b) => a.tier - b.tier);
export function getUpgradePlan(currentSlug) {
  var _SORTED_PLANS$find;
  const current = SORTED_PLANS.find(p => p.slug === currentSlug);
  if (!current) return null;
  return (_SORTED_PLANS$find = SORTED_PLANS.find(p => p.tier > current.tier)) != null ? _SORTED_PLANS$find : null;
}
export function getFeatureMatrix() {
  const planEntries = Object.entries(PLAN_DEFINITIONS);
  return Object.values(PlanFeature).map(feature => {
    const category = PLAN_FEATURE_CATEGORIES[feature];
    return {
      feature,
      label: PLAN_FEATURE_LABELS[feature],
      category,
      category_label: PLAN_FEATURE_CATEGORY_LABELS[category],
      plans: Object.fromEntries(planEntries.map(([slug, plan]) => [slug, plan.features.includes(feature)]))
    };
  });
}
export function getPlansForFeature(feature) {
  return Object.entries(PLAN_DEFINITIONS).filter(([, plan]) => plan.features.includes(feature)).map(([slug]) => slug);
}
//# sourceMappingURL=plans.js.map